<template>
  <div class="lb">
    <div class="ctn1" @click="playVideo()">
      <img
        class="play"
        src="@/assets/temimg6/video_play.png"
        alt=""
        v-if="isvideo"
      />
      <div class="video_img">
        <div class="corner top-left"></div>
        <div class="corner top-right"></div>
        <div class="corner bottom-left"></div>
        <div class="corner bottom-right"></div>
        <video
          ref="videoRef"
          :src="defaultdata[0].value1"
          type="video/mp4"
          :controls="!isvideo"
          muted
          :autoplay="!isvideo"
          loop
          :poster="isvideo ? defaultdata[0].value2 : ''"
        ></video>
      </div>
    </div>
  </div>
</template>

<script>
import * as methods from "./method.js";
export default {
  name: "template.scope81",
  props: {
    vdata: {
      type: [Array, String],
      default: () => [],
    },
    jsondata: {
      type: [Array, String],
      default: () => [],
    },
    scopedata: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      title: "scope81-新数值条形图-完成",
      timer: null,
      defaultdata: [
        {
          value1: "http://121.4.173.197:8000/defaultimg/defaultvideo1.mp4",
          value2: "http://121.4.173.197:8000/defaultimg/default10.png",
        },
      ],
      valueMap: [
        { name: "视频地址", key: "value1" },
        { name: "视频封面", key: "value2" },
      ],
      exceldata: [],
      apiconfig: {},
      isApi: false,
      scope: {},
      scopelist: [],
      isvideo: false,
    };
  },
  watch: {
    vdata(n) {
      if (n && n.length) {
        this.defaultdata = n;
      }
    },
    jsondata(n) {
      this.exceldata = n;
    },
    defaultdata(n) {
      this.Drawdata();
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  },
  methods: {
    ...methods,
    Drawdata() {
      let linedata = JSON.parse(JSON.stringify(this.defaultdata));
      linedata = linedata.sort((a, b) => +b.value3 - +a.value3).slice(0, 10);
      this.scopelist = linedata;
    },
    playVideo() {
      const video = this.$refs.videoRef;
      if (this.isvideo) {
        this.isvideo = false;
        video.play().catch((error) => {
          console.error("视频播放出错:", error);
        });
      } else {
        this.isvideo = true;
        video.pause();
      }
    },
  },
  mounted() {
    if (this.vdata && this.vdata.length) {
      this.defaultdata = this.vdata;
    }
    if (this.jsondata && this.jsondata.length) {
      this.exceldata = this.jsondata;
    }
    this.setData()
    let host = window.location.host
    if (host == 'www.17886.cn') {
      let news = 'https://www.17886.cn'
      let olds = 'http://121.4.173.197:8000'
      this.defaultdata.forEach(item => {
        if (item.value1.includes(olds)) {
          item.value1 = item.value1.replace(olds, news)
          item.value2 = item.value1.replace(olds, news)
        }
      })
      this.defaultdata = [...this.defaultdata]
    }
    this.Drawdata(); //需要刷新的数据
  },
};
</script>

<style scoped lang="scss">
.lb {
  width: 435px;
  height: 240px;
  padding: 10px 0;
  display: flex;
  position: relative;
  overflow: hidden;

  .ctn1 {
    margin: 0 auto;
    width: 435px;
    height: 240px;
    box-sizing: border-box;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    .play {
      width: 79px;
      height: 79px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 5;
    }

    .video_img {
      width: 414px;
      height: 210px;
      border: 2px solid #32405e;
      padding: 2px;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #000;
      video {
        width: 98%;
        height: 98%;
      }

      img {
        width: 98%;
        height: 98%;
      }
    }

    .corner {
      background-image: url("@/assets/temimg6/corner.png");
      background-size: cover;
      position: absolute; /* 设置为绝对定位 */
      width: 18px; /* 设置 div 的宽度 */
      height: 18px; /* 设置 div 的高度 */
    }
    .top-left {
      top: -6px;
      left: -6px;
      transform: rotate(90deg);
    }

    .top-right {
      top: -6px;
      right: -6px;
      transform: rotate(-180deg);
    }

    .bottom-left {
      bottom: -6px;
      left: -6px;
      // transform: rotate(-45deg);
    }

    .bottom-right {
      bottom: -6px;
      right: -6px;
      transform: rotate(-90deg);
    }
  }
}
</style>
